import { useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import classNames from 'classnames'

import styles from './SafeBanking.module.scss'

const SafeBankingModal = ({ open, children, setOpen }) => {
  const [isClosing, setIsClosing] = useState(false)

  const handleClose = () => {
    setIsClosing(true)
    setTimeout(() => {
      setIsClosing(false)
      setOpen()
    }, 400)
  }

  return (
    <>
      <Modal
        show={open}
        onHide={handleClose}
        dialogClassName={classNames(styles['right-side-modal'], {
          [styles['slide-out']]: isClosing,
        })}
        contentClassName={classNames(styles['right-side-modal-content'])}
        backdropClassName={isClosing ? styles['slide-out'] : ''}
        animation={false}
      >
        {children}
      </Modal>
    </>
  )
}

export default SafeBankingModal
